import generateUtilityClasses from "../../utils/generateUtilityClasses/generateUtilityClasses.es.js";
import generateUtilityClass from "../../utils/generateUtilityClass/generateUtilityClass.es.js";
function getPickersDayUtilityClass(slot) {
  return generateUtilityClass("MuiPickersDay", slot);
}
const pickersDayClasses = generateUtilityClasses("MuiPickersDay", ["root", "dayWithMargin", "dayOutsideMonth", "hiddenDaySpacingFiller", "today", "selected", "disabled"]);
export {
  getPickersDayUtilityClass,
  pickersDayClasses
};
//# sourceMappingURL=pickersDayClasses.es.js.map
